'use strict';

(function(z, Backbone, Translator){

    var MaterialImportForm = Backbone.View.extend({

        el: '#import-materials-panel',

        UPLOAD_MAX_SIZE: 10000000,
        UPLOAD_ALLOWED_TYPES: [
            'text/csv',
            'text/plain',
            'application/vnd.ms-excel'
        ],

        events: {
            'click #material-import-upload-button': '_onUploadClick'
        },

        initialize: function() {
            this._bindModel();
            this._bindEvents();
        },

        _bindModel: function(model){
            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});
            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        _bindEvents: function(){
            this.listenTo(this.model, 'request', this._onModelRequest);
            this.listenTo(this.model, 'sync', this._onModelSync);
            this.listenTo(this.model, 'error', this._onModelError);
        },

        _onUploadClick: function(e) {
            e.preventDefault();

            this._hideMessages();

            var fileInput = document.querySelector('#import-template-field');
            var typeSelect = document.querySelector('#import-type-field');

            if (!typeSelect || !typeSelect.value) {
                this._showError('Selectează un tip de import!');
                return;
            }

            // verificări inițiale
            if (!fileInput || !fileInput.files.length) {
                this._showError('Selectează un fișier pentru import!');
                return;
            }

            var file = fileInput.files[0];

            if (!this._isValidUploadType(file.type)) {
                this._showError('Tipul fișierului nu este permis! Acceptate: CSV.');
                return;
            }

            if (!this._isValidUploadSize(file.size)) {
                this._showError('Fișierul este prea mare! Dimensiune maximă 10MB.');
                return;
            }

            // dacă trece toate validările locale → se trimite
            this._uploadTemplate();
        },

        _onValid: function(view, attr){
            var $form = this.$('form');
            $form.find('[data-validation="' + attr + '"]')
                .removeClass('has-error')
                .find('.help-block')
                .addClass('hidden')
                .text('');
        },

        _onInvalid: function(view, attr, error){
            var $form = this.$('form');
            $form.find('[data-validation="' + attr + '"]')
                .addClass('has-error')
                .find('.help-block')
                .removeClass('hidden')
                .text(error);
        },

        _onModelRequest: function(){
            this._setLoading(true);
        },

        _onModelSync: function(){
            this._setLoading(false);
        },

        _onModelError: function(model, res){
            this._setLoading(false);
        },

        _uploadTemplate: function(){
            this._setLoading(true);
            var data = this._getFormData(this.model);

            Backbone.ajax({
                url: '/material/import',
                type: 'POST',
                data: data,
                processData: false,
                contentType: false,
                success: function(res) {
                    this._setLoading(false);

                    var data = res.data || {};
                    var errors = res.errors || [];

                    if (!data.inserted && !data.updated && !data.total) {
                        errors.push("Importul de piese a esuat.");
                    }

                    this._showImportMessages(data, errors);
                    this._resetForm();
                }.bind(this),
                error: function(xhr){
                    this._setLoading(false);
                    var errors = [];
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        errors = xhr.responseJSON.errors.map(e => e.message);
                    } else {
                        errors.push("Eroare la import. Verificați fișierul!");
                    }
                    this._showImportMessages({}, errors);
                }.bind(this)
            });
        },

        _resetForm: function(){
            this.$('form').get(0).reset();
        },

        _getFormData: function(){
            var data = new FormData();
            var fileInput = document.querySelector('#import-template-field');
            var typeSelect = document.querySelector('#import-type-field');
            if (fileInput && fileInput.files.length > 0) {
                data.append('material_import_form[template]', fileInput.files[0]);
            }
            if (typeSelect && typeSelect.value) {
                data.append('material_import_form[type]', typeSelect.value);
            }
            return data;
        },

        _isValidUploadType: function(type){
            return this.UPLOAD_ALLOWED_TYPES.indexOf(type) >= 0;
        },

        _isValidUploadSize: function(size){
            return size <= this.UPLOAD_MAX_SIZE;
        },

        _setLoading: function(loading){
            var $spinner = this.$('#import-loading');
            if (loading) {
                $spinner.show();
            } else {
                $spinner.hide();
            }
        },

        _showImportMessages: function(data, errors){
            var $error = this.$('#import-errors-holder');
            $error.empty();

            if (errors && errors.length) {
                errors.forEach(function(msg){
                    $('<span>').addClass('help-block text-left text-danger').text(msg).appendTo($error);
                });
                this.$('#import-errors').removeClass('hidden').fadeIn('slow');
            }

            if (data && (data.inserted || data.updated || data.total)) {
                var successMsg = 'Import reușit: ' +
                    (data.inserted ? data.inserted + ' adăugate, ' : '') +
                    (data.updated ? data.updated + ' modificate, ' : '') +
                    (data.total ? 'total ' + data.total : '');
                var $success = $('#import-success-message');
                // if ($success) {
                $success = $('<div id="import-success-message" class="alert alert-success text-left mt-2 hidden"></div>');
                this.$el.prepend($success);
                // }
                $success.text(successMsg)
                    .removeClass('hidden')
                    .fadeOut(0).fadeIn('slow')
                    .delay(5000)
                    .fadeOut('slow', function(){ $success.addClass('hidden'); });
            }
        },

        _hideMessages: function(){
            this.$('#import-errors').addClass('hidden').fadeOut('fast');
            var $success = $('#import-success-message');
            $success.addClass('hidden').hide();
        },

        _showError: function(message){
            var $error = $('#import-error-message');
            if (!$error.length) {
                $error = $('<div id="import-error-message" class="alert alert-danger text-left mt-2 hidden"></div>');
                this.$el.prepend($error);
            }
            $error.text(message)
                .removeClass('hidden')
                .fadeOut(0).fadeIn('slow')
                .delay(4000)
                .fadeOut('slow', function(){ $error.addClass('hidden'); });
        }

    });

    z.MaterialImportForm = MaterialImportForm;

})(window.z = window.z || {}, Backbone, Translator);
